var Navigation = require('../modules/navigation');
new Navigation();



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/navigation.initializer.js